import { Controller } from "@hotwired/stimulus"

// learned-term-row — flips a Learned Terms row between display mode and
// edit mode. In edit mode the product cell becomes a select and the
// action cell shows Save/Cancel buttons; in display mode the original
// labels and Edit/Delete buttons are visible. Pure show/hide — the form
// submit is plain Rails, no AJAX.
export default class extends Controller {
    static targets = ["view", "edit"]

    edit(event) {
        if (event) event.preventDefault()
        this.viewTargets.forEach(el => (el.style.display = "none"))
        this.editTargets.forEach(el => (el.style.display = ""))
    }

    cancel(event) {
        if (event) event.preventDefault()
        this.viewTargets.forEach(el => (el.style.display = ""))
        this.editTargets.forEach(el => (el.style.display = "none"))
    }
}
